import axios from "axios";

// Base URL setup
const baseURL =
  import.meta.env.VITE_BACKEND_URL ||
  "https://api.indiancouriercompany.com/api";
// const baseURL = import.meta.env.VITE_BACKEND_URL || "http://localhost:5000/api";
// const baseURL = import.meta.env.VITE_BACKEND_URL || "https://stinkbug-helping-killdeer.ngrok-free.app/api";
// const baseURL = import.meta.env.VITE_BACKEND_URL || "https://stinkbug-helping-killdeer.ngrok-free.app/api";

const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "any-value", // Optional header for ngrok
  },
  withCredentials: true, // Required for cookies
});

// Generic request function
export const request = async ({
  endpoint,
  method = "GET",
  body = null,
  params = null,
  headers = {},
  responseType = "json",
}) => {
  const token = localStorage.getItem("token");

  try {
    const config = {
      method,
      url: endpoint,
      data: body,
      params,
      responseType,
      headers: {
        ...axiosInstance.defaults.headers.common, // Include instance headers
        ...headers, // Merge with request-specific headers
        Authorization: `Bearer ${token}`,
      },
    };
    console.log("Config:::::", config);
    const response = await axiosInstance(config);
    console.log("api's Response:::::", response);
    return response.data; // Return only the response data
  } catch (error) {
    // Extract error details
    console.log("Error:::::", error);
    if (
      error?.response?.data?.success === false &&
      error?.response?.data?.error?.code === "INVALID_TOKEN"
    ) {
      localStorage.removeItem("token");
      alert("Session expired. Please log in again.");
      window.location.href = "/login";
      return;
    }
    const errorMessage =
      error.response?.data || error.message || "An unexpected error occurred.";
    const statusCode = error.response?.status;
    console.error("API request failed:", errorMessage, statusCode);

    // Throw an enhanced error object
    throw {
      msg: error.response?.data?.error,
      status: statusCode, // HTTP status code (if available)
      ...errorMessage, // User-friendly error message
    };
  }
};

export default axiosInstance;
